import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const PAIRS = ['USDINR', 'EURINR', 'GBPINR', 'JPYINR', 'EURUSD'];

export default function Alerts() {
  const { API, token, userId } = useAuth();

  const [alerts,   setAlerts]   = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [saving,   setSaving]   = useState(false);
  const [msg,      setMsg]      = useState('');

  const [pair,         setPair]         = useState('USDINR');
  const [rate,         setRate]         = useState('');
  const [triggerRange, setTriggerRange] = useState('');

  useEffect(() => { fetchAlerts(); }, []);

  const fetchAlerts = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        API + '/alerts?clientId=' + userId,
        { headers: { Authorization: 'Bearer ' + token } }
      );
      setAlerts(res.data);
    } catch (e) {
      setMsg('Failed to load alerts');
    } finally {
      setLoading(false);
    }
  };

  const saveAlert = async () => {
    if (!rate || isNaN(parseFloat(rate))) {
      setMsg('Please enter a valid target rate'); return;
    }
    if (!triggerRange || isNaN(parseFloat(triggerRange)) || parseFloat(triggerRange) <= 0) {
      setMsg('Please enter a valid trigger range'); return;
    }
    try {
      setSaving(true);
      await axios.post(API + '/alerts', {
        clientID:     parseInt(userId),
        currencyPair: pair,
        targetRate:   parseFloat(rate),
        triggerRange: parseFloat(triggerRange),
        message:      '',
      }, { headers: { Authorization: 'Bearer ' + token } });
      setMsg('');
      setRate('');
      setTriggerRange('');
      setShowForm(false);
      fetchAlerts();
    } catch (e) {
      setMsg('Failed to save alert');
    } finally {
      setSaving(false);
    }
  };

  const deleteAlert = async (id) => {
    try {
      await axios.delete(
        API + '/alerts/' + id,
        { headers: { Authorization: 'Bearer ' + token } }
      );
      fetchAlerts();
    } catch (e) {
      setMsg('Failed to delete alert');
    }
  };

  const toggleAlert = async (id) => {
    try {
      await axios.put(
        API + '/alerts/' + id + '/toggle',
        {},
        { headers: { Authorization: 'Bearer ' + token } }
      );
      fetchAlerts();
    } catch (e) {
      setMsg('Failed to update alert');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#F8FAFC', paddingBottom: '80px' }}>

      {/* HEADER */}
      <div style={{
        background: '#1B3A6B', padding: '12px 16px',
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky', top: 0, zIndex: 50,
      }}>
        <div>
          <div style={{ fontFamily: 'Arial', fontSize: '14px', fontWeight: 700, color: '#D4A843', letterSpacing: '0.08em' }}>
            RATE ALERTS
          </div>
          <div style={{ fontFamily: 'Arial', fontSize: '10px', color: '#93C5FD', marginTop: '2px' }}>
            WhatsApp notifications — max 3 per alert per day
          </div>
        </div>
        <button
          onClick={() => { setShowForm(!showForm); setMsg(''); }}
          style={{
            background: showForm ? '#8B6914' : '#D4A843',
            border: 'none', borderRadius: '20px',
            padding: '8px 16px', color: '#1B3A6B',
            fontFamily: 'Arial', fontSize: '12px',
            fontWeight: 700, cursor: 'pointer',
          }}>
          {showForm ? 'CANCEL' : '+ NEW ALERT'}
        </button>
      </div>

      <div style={{ maxWidth: '600px', margin: '0 auto', padding: '16px' }}>

        {/* ERROR MESSAGE */}
        {msg !== '' && (
          <div style={{
            background: '#FEE2E2', border: '1px solid #FECACA',
            borderRadius: '8px', padding: '10px 14px',
            fontFamily: 'Arial', fontSize: '12px',
            color: '#DC2626', marginBottom: '12px',
          }}>
            {msg}
          </div>
        )}

        {/* NEW ALERT FORM */}
        {showForm && (
          <div style={{
            background: '#fff', borderRadius: '12px',
            border: '1px solid #E5E7EB',
            padding: '20px', marginBottom: '16px',
          }}>
            <div style={{ fontFamily: 'Arial', fontSize: '13px', fontWeight: 700, color: '#1B3A6B', marginBottom: '16px' }}>
              NEW ALERT
            </div>

            {/* Currency Pair */}
            <label style={{ display: 'block', fontFamily: 'Arial', fontSize: '11px', fontWeight: 600, color: '#6B7280', letterSpacing: '0.08em', marginBottom: '6px' }}>
              CURRENCY PAIR
            </label>
            <select
              value={pair}
              onChange={e => setPair(e.target.value)}
              style={{
                display: 'block', width: '100%',
                background: '#F8FAFC', border: '1px solid #D1D5DB',
                borderRadius: '8px', padding: '10px 14px',
                fontSize: '14px', fontWeight: 600,
                color: '#111827', marginBottom: '14px',
                outline: 'none', boxSizing: 'border-box',
              }}>
              {PAIRS.map(p => <option key={p} value={p}>{p}</option>)}
            </select>

            {/* Target Rate + Trigger Range */}
            <div style={{ display: 'flex', gap: '10px', marginBottom: '14px' }}>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', fontFamily: 'Arial', fontSize: '11px', fontWeight: 600, color: '#6B7280', letterSpacing: '0.08em', marginBottom: '6px' }}>
                  TARGET RATE
                </label>
                <input
                  type="number"
                  step="0.0001"
                  value={rate}
                  onChange={e => setRate(e.target.value)}
                  placeholder="e.g. 84.50"
                  style={{
                    display: 'block', width: '100%',
                    background: '#F8FAFC', border: '1px solid #D1D5DB',
                    borderRadius: '8px', padding: '10px 14px',
                    fontSize: '14px', color: '#111827',
                    outline: 'none', boxSizing: 'border-box',
                  }}
                />
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ display: 'block', fontFamily: 'Arial', fontSize: '11px', fontWeight: 600, color: '#6B7280', letterSpacing: '0.08em', marginBottom: '6px' }}>
                  TRIGGER RANGE (±)
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={triggerRange}
                  onChange={e => setTriggerRange(e.target.value)}
                  placeholder="e.g. 0.25"
                  style={{
                    display: 'block', width: '100%',
                    background: '#F8FAFC', border: '1px solid #D1D5DB',
                    borderRadius: '8px', padding: '10px 14px',
                    fontSize: '14px', color: '#111827',
                    outline: 'none', boxSizing: 'border-box',
                  }}
                />
              </div>
            </div>

            {/* Range Preview */}
            {rate && triggerRange && !isNaN(parseFloat(rate)) && !isNaN(parseFloat(triggerRange)) && (
              <div style={{
                background: '#F0FDF4', border: '1px solid #BBF7D0',
                borderRadius: '8px', padding: '10px 14px',
                fontFamily: 'Arial', fontSize: '12px',
                color: '#15803D', marginBottom: '14px',
                textAlign: 'center', fontWeight: 600,
              }}>
                Alert will fire when {pair} is between{' '}
                <strong>{(parseFloat(rate) - parseFloat(triggerRange)).toFixed(4)}</strong>
                {' '}and{' '}
                <strong>{(parseFloat(rate) + parseFloat(triggerRange)).toFixed(4)}</strong>
              </div>
            )}

            {/* Info box */}
            <div style={{
              background: '#EFF6FF', border: '1px solid #BFDBFE',
              borderRadius: '8px', padding: '10px 14px',
              fontFamily: 'Arial', fontSize: '11px',
              color: '#1D4ED8', marginBottom: '16px',
              lineHeight: '1.6',
            }}>
              ℹ️ Alert will be sent to your registered WhatsApp number.<br />
              Maximum 3 alerts per rate level per day.<br />
              Minimum 30 minute gap between each alert.
            </div>

            <button
              onClick={saveAlert}
              disabled={saving}
              style={{
                width: '100%', background: saving ? '#9CA3AF' : '#1B3A6B',
                border: 'none', borderRadius: '8px',
                padding: '12px', color: '#fff',
                fontFamily: 'Arial', fontSize: '14px',
                fontWeight: 700, cursor: saving ? 'not-allowed' : 'pointer',
              }}>
              {saving ? 'Saving...' : 'SAVE ALERT'}
            </button>
          </div>
        )}

        {/* ALERTS LIST */}
        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#9CA3AF', fontFamily: 'Arial' }}>
            Loading alerts...
          </div>
        ) : alerts.length === 0 ? (
          <div style={{
            textAlign: 'center', padding: '40px',
            background: '#fff', borderRadius: '12px',
            border: '1px solid #E5E7EB',
          }}>
            <div style={{ fontSize: '36px', marginBottom: '12px' }}>🔔</div>
            <div style={{ fontFamily: 'Arial', fontSize: '14px', color: '#374151', fontWeight: 500 }}>
              No alerts set
            </div>
            <div style={{ fontFamily: 'Arial', fontSize: '12px', color: '#9CA3AF', marginTop: '6px' }}>
              Tap + NEW ALERT to create your first alert
            </div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {alerts.map(alert => (
              <div key={alert.alertID} style={{
                background: '#fff', borderRadius: '12px',
                border: '1px solid ' + (alert.isActive ? '#E5E7EB' : '#F3F4F6'),
                padding: '14px 16px',
                opacity: alert.isActive ? 1 : 0.6,
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div style={{ flex: 1 }}>

                    {/* Pair + Target Rate */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                      <span style={{
                        background: '#1B3A6B', color: '#fff',
                        fontFamily: 'Arial', fontSize: '12px',
                        fontWeight: 700, padding: '3px 8px',
                        borderRadius: '4px',
                      }}>
                        {alert.currencyPair}
                      </span>
                      <span style={{ fontFamily: 'monospace', fontSize: '15px', fontWeight: 700, color: '#111827' }}>
                        Target: {parseFloat(alert.targetRate).toFixed(4)}
                      </span>
                    </div>

                    {/* Range display */}
                    <div style={{
                      background: '#F0FDF4', border: '1px solid #BBF7D0',
                      borderRadius: '6px', padding: '6px 10px',
                      fontFamily: 'Arial', fontSize: '11px',
                      color: '#15803D', marginBottom: '6px',
                      fontWeight: 600,
                    }}>
                      🎯 Fires between{' '}
                      {(parseFloat(alert.targetRate) - parseFloat(alert.triggerRange)).toFixed(4)}
                      {' — '}
                      {(parseFloat(alert.targetRate) + parseFloat(alert.triggerRange)).toFixed(4)}
                      {'  (±' + parseFloat(alert.triggerRange).toFixed(2) + ')'}
                    </div>

                    {/* Status row */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span style={{
                        background: alert.isActive ? '#F0FDF4' : '#F3F4F6',
                        color: alert.isActive ? '#16A34A' : '#9CA3AF',
                        fontFamily: 'Arial', fontSize: '10px',
                        fontWeight: 700, padding: '2px 8px',
                        borderRadius: '10px',
                      }}>
                        {alert.isActive ? 'ACTIVE' : 'PAUSED'}
                      </span>
                      <span style={{ fontFamily: 'Arial', fontSize: '10px', color: '#9CA3AF' }}>
                        Sent {alert.sendCountToday}/{alert.maxPerDay} today
                      </span>
                      {alert.lastSentAt && (
                        <span style={{ fontFamily: 'Arial', fontSize: '10px', color: '#9CA3AF' }}>
                          Last: {new Date(alert.lastSentAt).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Action buttons */}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginLeft: '12px' }}>
                    <button
                      onClick={() => toggleAlert(alert.alertID)}
                      style={{
                        background: alert.isActive ? '#FEF3C7' : '#F0FDF4',
                        border: 'none', borderRadius: '6px',
                        padding: '6px 10px', cursor: 'pointer',
                        fontFamily: 'Arial', fontSize: '11px',
                        fontWeight: 600,
                        color: alert.isActive ? '#D97706' : '#16A34A',
                      }}>
                      {alert.isActive ? 'PAUSE' : 'RESUME'}
                    </button>
                    <button
                      onClick={() => deleteAlert(alert.alertID)}
                      style={{
                        background: '#FEF2F2', border: 'none',
                        borderRadius: '6px', padding: '6px 10px',
                        cursor: 'pointer', fontFamily: 'Arial',
                        fontSize: '11px', fontWeight: 600,
                        color: '#DC2626',
                      }}>
                      DELETE
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}